import { Menu, Portal } from '@chakra-ui/react';
import { FC, PropsWithChildren, ReactNode } from 'react';

export const NavMenu: FC<PropsWithChildren<{ content: ReactNode }>> = ({
  children,
  content,
}) => {
  return (
    <Menu.Root
      positioning={{
        placement: 'right-end',
        offset: { mainAxis: 16, crossAxis: -10 },
      }}
      variant={'subtle'}
    >
      <Menu.Trigger asChild>{children}</Menu.Trigger>
      <Portal>
        <Menu.Positioner>
          <Menu.Content>{content}</Menu.Content>
        </Menu.Positioner>
      </Portal>
    </Menu.Root>
  );
};
